export default class Locale_PFErrorBoundary {
	SomethingWentWrong: string = `Something went wrong, trying to display the [[component]]..`;
	TryRefreshingThisComponent: string = `Try refreshing the [[component]]..`;
	RefreshingWasNotEnough: string = `Refreshing the [[component]] wasn't enough! Try resetting it instead..`;
	Resetting: string = "Resetting";
	Refreshing: string = "Refreshing";
	ResetOrRefreshWasNotEnough: string = "the [[component]] wasn't enough! Try reloading the entire page..";
}